module.exports = __webpack_public_path__ + "media/images/vector-5@2x-134fd8645a95a31626687ad868d0e9fc.png";